///include /assets/js/app/p/checkout.js
class CheckoutPaddle extends CheckoutDriver {
    get requiresImmediateSelection() {
        return false
    }
}

CheckoutDriver.byName.paddle = CheckoutPaddle
